import { oc } from '@orpc/contract';
import { removeSimulatorEstimateInputSchema, removeSimulatorEstimateOutputSchema } from '../schemas/simulator.schemas.js';
/** Deletes one saved evaluation. `removed: false` when the row was already gone. */
export const removeSimulatorEstimateContract = oc
    .route({
    method: 'DELETE',
    path: '/simulator/estimates/{id}',
    tags: ['Simulator'],
    summary: 'Remove a saved simulator evaluation',
})
    .input(removeSimulatorEstimateInputSchema)
    .output(removeSimulatorEstimateOutputSchema);
//# sourceMappingURL=remove-simulator-estimate.contract.js.map